import { RouteConfig, Route } from 'vue-router';
import Layout from '@/layout/index.vue';
import { AppRoleType } from '@/utils/permission';

const ticketSettingRoutes: RouteConfig = {
  path: '/ticketsetting',
  component: Layout,
  redirect: '/ticketsetting/list',
  meta: {
    title: 'Ticket setting',
    icon: 'mdi-credit-card-settings-outline',
    alwaysShow: true,
    roles: [AppRoleType.ADMIN, AppRoleType.TICKET_SETTING_EDITOR],
  },
  children: [
    {
      path: 'list',
      component: () =>
        import(
          /* webpackChunkName: "ticketsetting" */ '@/views/ticketsetting/list/index.vue'
        ),
      name: 'ticketsetting-list',
      meta: {
        title: 'Ticket setting list',
        icon: 'mdi-credit-card-multiple-outline',
        roles: [AppRoleType.ADMIN, AppRoleType.TICKET_SETTING_EDITOR],
      },
    },
    {
      path: 'create',
      component: () =>
        import(
          /* webpackChunkName: "ticketsetting" */ '@/views/ticketsetting/create/index.vue'
        ),
      name: 'ticketsetting-create',
      meta: {
        title: 'Ticket setting create',
        icon: 'mdi-credit-card-plus-outline',
        roles: [AppRoleType.ADMIN, AppRoleType.TICKET_SETTING_EDITOR],
      },
    },
    {
      path: ':id',
      component: () =>
        import(
          /* webpackChunkName: "ticketsetting" */ '@/views/ticketsetting/detail/index.vue'
        ),
      name: 'ticketsetting-detail',
      meta: {
        title: 'Ticket setting detail',
        icon: 'mdi-credit-card-scan-outline',
        hidden: true,
        roles: [AppRoleType.ADMIN, AppRoleType.TICKET_SETTING_EDITOR],
      },
      props: route => ({
        id: route.params.id,
        // ticket: route.params.ticket,
      }),
    },
  ],
};

export default ticketSettingRoutes;
